"use client";

import { useEffect, useState } from "react";
import Image from "next/image";
import logo from "@/assets/images/logos/AlfaMall-Logo 90x90 px-01.png";
import {
  APP_BANNER_OPEN_LABEL,
  APP_BANNER_SUBTITLE,
  APP_BANNER_TITLE,
  isAppBannerDismissed,
  openApp,
  rememberAppBannerDismissed,
} from "./getOurAppConfig";
import "./GetOurApp.scss";

export default function GetOurAppBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isAppBannerDismissed()) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  return (
    <div className="get-our-app-banner">
      <Image
        className="get-our-app-banner-logo"
        src={logo}
        alt="AlfaMall"
        width={40}
        height={40}
      />
      <div className="get-our-app-banner-copy">
        <span className="get-our-app-banner-title">{APP_BANNER_TITLE}</span>
        <span className="get-our-app-banner-subtitle">{APP_BANNER_SUBTITLE}</span>
      </div>
      <button
        type="button"
        className="get-our-app-banner-open"
        onClick={openApp}
      >
        {APP_BANNER_OPEN_LABEL}
      </button>
    </div>
  );
}
